import React from "react"
import { Filtering } from "../../components"
import video from "../../../assets/icons/Beach-34259.mp4"
import styles from "./Banner.scss"

interface IProps {
  selectedCategories: [string]
  setSelectedCategories: (category: string) => void
  setSearchedLocation: (category: string) => void
  setNumberOfPeople: (category: string) => void
  setBudget: (category: string) => void
  setStartDate: (date: Date) => void
  setEndDate: (date: Date) => void
  onSearch: () => void
  categories: [string]
  budget: number
  numberOfPeople: number
  startDate: Date
  endDate: Date
  searchedLocation: { lat: string; lng: string; description: string }
}

const Banner = ({
  setSelectedCategories,
  setSearchedLocation,
  setNumberOfPeople,
  setBudget,
  setStartDate,
  setEndDate,
  startDate,
  endDate,
  onSearch,
  categories,
  searchedLocation,
  selectedCategories,
  budget,
  numberOfPeople,
}: IProps) => {
  return (
    <div className={styles.banner}>
      <video loop={true} autoPlay={true} muted={true}>
        <source src={video} type="video/mp4" />
      </video>
      <div>
        <div>
          <h1>ALLEZ GO !</h1>
          <h1>
            Connecte les curieux
            <br />
            et les passionné(es)
          </h1>
          <br />
        </div>
        <Filtering
          onSearch={onSearch}
          categories={categories}
          startDate={startDate}
          endDate={endDate}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          selectedCategories={selectedCategories}
          setSelectedCategories={setSelectedCategories}
          setSearchedLocation={setSearchedLocation}
          setNumberOfPeople={setNumberOfPeople}
          setBudget={setBudget}
          budget={budget}
          numberOfPeople={numberOfPeople}
          searchedLocation={searchedLocation}
        />
      </div>
    </div>
  )
}

export default Banner
